export default __webpack_public_path__ + "static/media/bottom_left.5a9d393e.png";